import React, { FormEvent, useState } from 'react';
import { BackButton, Container, Content } from './styles';
import logo from '../../assets/logo.svg';
import { useNavigate } from 'react-router-dom';
import { BiArrowBack } from 'react-icons/bi';
import { toast } from 'react-toastify';
import { apiProd } from '../../services/api';

function RecoveryCode() {
  const [code, setCode] = useState<number>();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const user = localStorage.getItem('user');
  async function handleVerification(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    if (user) {
      const { id } = JSON.parse(user);
      const data = {
        id: id,
        recovery_code: code,
      };
      const response = await apiProd.post('verify-code', data);
      if (response.data === true) {
        navigate('/define-new-password');
        setLoading(false);
      } else {
        setLoading(false);
        toast.error('Código de verificação inválido ou expirado', {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
        return;
      }
    }
  }
  return (
    <Container>
      <BackButton onClick={() => navigate(-1)}>
        <BiArrowBack size={32} />
        <span>Voltar</span>
      </BackButton>
      <Content
        initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        onSubmit={handleVerification}
      >
        <img src={logo} alt="Logo cdl negocia" />
        <p>Confirme o código que foi enviado para o seu email.</p>
        <input
          className="code"
          type="text"
          required={true}
          value={code}
          onChange={(e) => setCode(Number(e.target.value))}
          maxLength={6}
          pattern="[0-9]{6}"
        />
        {loading ? (
          <div className="lds-dual-ring" />
        ) : (
          <button type="submit" disabled={loading ? true : false}>
            Verificar
          </button>
        )}
      </Content>
    </Container>
  );
}

export default RecoveryCode;
